import {
	OperationRegulationsEnum,
	OperationStatusEnumFR
} from '@app/models/api/enums/OperationStatusEnum';
import { urls } from '@app/urls';
import { page } from '$app/stores';
import { get } from 'svelte/store';

//https://decipher.dev/30-seconds-of-typescript/docs/debounce/
export const debounce = (fn: Function, ms = 300) => {
	let timeoutId: ReturnType<typeof setTimeout>;
	return function (this: any, ...args: any[]) {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => fn.apply(this, args), ms);
	};
};

export const debounceAsync = (fn: Function, ms = 300) => {
	let timeoutId: ReturnType<typeof setTimeout>;
	return function (this: any, ...args: any[]) {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(async () => await fn.apply(this, args), ms);
	};
};

export const numberWithSpaces = (x: number): string => {
	const parts = x.toString().split('.');
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	return parts.join('.');
};

// let timer: ReturnType<typeof setTimeout>;
//
// const debounce = (afterReactivity: any, beforeReactivity: any) => {
//   clearTimeout(timer);
//   timer = setTimeout(() => {
//     beforeReactivity = afterReactivity;
//   }, 750);
// };

export const logInvalidFormInputs = (inputs: Array<any>) => {
	inputs.forEach((e) => {
		if (e.validation && !e.validation.valid) {
			//console.log(e);
		}
	});
};

export const generateCanonicalLink = (page): string | null => {
	const pathname = page?.url?.pathname + page?.url?.search;
	const reglementations = page?.url?.searchParams.get('reglementations');
	const statuts = page?.url?.searchParams.get('statuts');

	if (pathname.startsWith('/projets')) {
		const includeProjetsURL = isProjetsURLIncluded(reglementations, statuts);
		return includeProjetsURL ? page?.url?.href : null;
	} else if (pathname.startsWith('/projet/')) {
		const includeProjetURL = isProjectURLIncluded(page?.params?.slug ?? page?.url?.pathname);
		return includeProjetURL ? page?.url?.href : null;
	} else {
		return page?.url?.href.split('?')[0];
	}
};

const isProjetsURLIncluded = (reglementations: string, statuts: string): boolean => {
	const isPSIOrPSFP =
		reglementations === OperationRegulationsEnum.PSI ||
		reglementations === OperationRegulationsEnum.PSFP;
	const isEnFinancement = statuts === OperationStatusEnumFR.EN_FINANCEMENT;
	return isPSIOrPSFP && isEnFinancement;
};

const isProjectURLIncluded = (slug: string): boolean => {
	return slug.split('/').length === 1;
};

export const minimumFeesFreeInvestment = 1000;
export const acceptedFormatsForUserDocument =
	'application/pdf, image/png, image/jpeg, image/jpg, image/gif, image/heic';
export const wiseedPhoneNumber = '+33970832323';
export const getRedirectWalletTransactionUrl = (transactionUuid: string) => {
	const $page = get(page);
	return `${$page.url!.protocol}//${$page.url!.host}${urls.USER.WALLET.INDEX}/${transactionUuid}`;
};
